import UnAuthenticatedRequest from 'services/requests/UnAuthenticated';
import apiUrlConfig from 'configs/apiUrlConfig';

const URLS = {
  SIGN_UP: `${apiUrlConfig.apiEndPoint()}/subscriptions`,
};

class SignUp {
  static subscribe(email) {
    return UnAuthenticatedRequest.post(URLS.SIGN_UP, {
      subscription: {
        email,
      },
    });
  }
}

export default SignUp;



// WEBPACK FOOTER //
// ./src/apis/SignUp.js